import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { RealEstateGridComponent } from './real-estate-grid/real-estate-grid.component';
import { RealEstateDetailComponent } from './real-estate-detail/real-estate-detail.component';
import { RealEstateRoutingModule } from './real-estate.routing';
import { DealerComponent } from './dealer/dealer.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SharedModule } from 'src/app/shared.module';
import { RealEstateDealerInfoComponent } from './real-estate-dealer-info/real-estate-dealer-info.component';
import { MoreAdsComponent } from './more-ads/more-ads.component';
import { OwlModule } from 'ngx-owl-carousel';
import { ViewPropertyComponent } from './view-property/view-property.component';


@NgModule({
  declarations: [HomeComponent, RealEstateGridComponent, RealEstateDetailComponent, DealerComponent, PageNotFoundComponent, RealEstateDealerInfoComponent, MoreAdsComponent, ViewPropertyComponent],
  imports: [
    CommonModule,
    SharedModule,
    RealEstateRoutingModule,
    OwlModule
  ],
  exports:[
    RealEstateDealerInfoComponent,
    RealEstateDetailComponent,
    ]
})
export class RealEstateModule { }
